import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as actions from '../../preInscripcion/_redux/pasoCinco/pasoCincoActions';
//import * as actionsInscripcion from '../../preInscripcion/_redux/inscripcion/inscripcionActions';

//ISO PAISES/PROVINCIAS
import Countries from '../../../../../_metronic/countries/Countries';

//BOTONES
import Volver from '../components/Volver';
import { Button, Spinner } from 'react-bootstrap';

//CONTEXO
import { PreInscripcionUIConsumer } from '../PreInscripcionUIContext';

//ICONOS
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//MATERIAL UI
import { ExpansionPanel, ExpansionPanelSummary, Card, CardContent } from '@material-ui/core';

import SnackBarCustom from '../../../Comun/SnackBars/SnackBarCustom';

const Resumen = (props) => {
    //const { confirmarInscripcion } = useContext(PreInscripcionUIContext);
    const { setHome, limpiarContenido } = props;

    const { pasoCinco } = useSelector(
        (state) => ({ pasoCinco: state.pasoCinco }),
        shallowEqual
    );

    const {
        actionsLoading,
        pasoCincoInformacion,
        error
    } = pasoCinco;

    useEffect(() => {
        if (!actionsLoading && !error && pasoCincoInformacion) {
            scrollTop();
            setTimeout(() => {
                limpiarContenido();
                setHome(true);
            }, 400);
        }
    }, [actionsLoading, pasoCincoInformacion, error])


    const paises = Countries();
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const dispatch = useDispatch();

    return (
        <PreInscripcionUIConsumer>
            {value =>
                <>
                    <h3 className="text-center" >RESÚMEN</h3>
                    <b>Inscripción {value.valoresExtrasAspirante().inscripcionNumero}</b>
                    <Card className="mt-4" style={{ backgroundColor: "#f7f7f7" }}>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div>
                                    <p>DATOS DEL ASPIRANTE</p>
                                    <div className="d-flex flex-row">
                                        <b className="mr-3">{value.detalleAspirante().apellido}, {value.detalleAspirante().nombre}</b>
                                        <b className="ml-3">DNI {value.detalleAspirante().documentoNumero}</b>
                                    </div>
                                </div>
                            </ExpansionPanelSummary>
                            <CardContent>
                                <h5>Datos personales</h5>
                                <div className="d-flex border-bottom">
                                    <div className="col-6" >
                                        <p>Fecha de nacimiento</p>
                                        <b>{value.detalleAspirante().fechaNacimiento.getDate()}/{value.detalleAspirante().fechaNacimiento.getMonth() + 1}/{value.detalleAspirante().fechaNacimiento.getFullYear()}</b>
                                    </div>
                                    <div className="col-6">
                                        <p>Edad</p>
                                        <b>{value.detalleAspirante().edad}</b>
                                    </div>
                                </div>
                                <div className="d-flex border-bottom">
                                    <div className="col-6" >
                                        <p>País</p>
                                        <b>{paises[parseInt(value.detalleAspirante().pais)].countryName}</b>
                                    </div>
                                </div>
                                <div className="d-flex border-bottom">
                                    <div className="col-6" >
                                        <p>Provincia</p>
                                        <b>{paises[parseInt(value.detalleAspirante().pais)].regions[parseInt(value.detalleAspirante().provincia)].name}</b>
                                    </div>
                                    <div className="col-6" >
                                        <p>Localidad</p>
                                        <b>{value.detalleAspirante().localidad}</b>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <h5>Domicilio</h5>
                                </div>
                                <div className="d-flex border-bottom">
                                    <div className="col-6" >
                                        <p>Calle</p>
                                        <b>{value.detalleAspirante().domicilio.calle}</b>
                                    </div>
                                    <div className="col-6" >
                                        <p>Número</p>
                                        <b>{value.detalleAspirante().domicilio.numero}</b>
                                    </div>
                                </div>
                                <div className="d-flex border-bottom">
                                    <div className="col-6" >
                                        <p>Piso</p>
                                        <b>{value.detalleAspirante().domicilio.piso}</b>
                                    </div>
                                    <div className="col-6" >
                                        <p>Departamento</p>
                                        <b>{value.detalleAspirante().domicilio.departamento}</b>
                                    </div>
                                </div>
                                <div className="d-flex border-bottom">
                                    <div className="col-6" >
                                        <p>Localidad</p>
                                        <b>{value.detalleAspirante().domicilio.localidad}</b>
                                    </div>
                                </div>
                            </CardContent>
                        </ExpansionPanel>
                    </Card>
                    {value.verResponsables().map((item, i) =>
                        <Card className="mt-4" key={i} style={{ backgroundColor: "#f7f7f7" }}>
                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <div>
                                        <div className="d-flex flex-row">
                                            <p className="mr-3">DATOS DEL RESPONSABLE </p>
                                            {i === value.responsablePrincipalPosicion() &&
                                                <b className="ml-3">PRINCIPAL</b>
                                            }
                                        </div>
                                        <div className="d-flex flex-row">
                                            <b className="mr-3">{item.apellido}, {item.nombre} ({item.vinculo})</b>
                                            <b className="ml-3">DNI {item.documentoNumero}</b>
                                        </div>
                                    </div>
                                </ExpansionPanelSummary>
                                <CardContent>
                                    <h5>Datos personales</h5>
                                    <div className="d-flex border-bottom">
                                        <div className="col-6" >
                                            <p>Fecha de nacimiento</p>
                                            <b>{item.fechaNacimiento.getDate()}/{item.fechaNacimiento.getMonth() + 1}/{item.fechaNacimiento.getFullYear()}</b>
                                        </div>
                                        <div className="col-6">
                                            <p>Correo</p>
                                            <b>{item.email}</b>
                                        </div>
                                    </div>
                                    <div className="d-flex border-bottom">
                                        <div className="col-6" >
                                            <p>País</p>
                                            <b>{paises[parseInt(item.pais)].countryName}</b>
                                        </div>
                                    </div>
                                    <div className="d-flex border-bottom">
                                        <div className="col-6" >
                                            <p>Provincia</p>
                                            <b>{paises[parseInt(item.pais)].regions[parseInt(item.provincia)].name}</b>
                                        </div>
                                        <div className="col-6" >
                                            <p>Localidad</p>
                                            <b>{item.localidad}</b>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <h5>Domicilio</h5>
                                    </div>
                                    <div className="d-flex border-bottom">
                                        <div className="col-6" >
                                            <p>Calle</p>
                                            <b>{item.domicilio.calle}</b>
                                        </div>
                                        <div className="col-6" >
                                            <p>Número</p>
                                            <b>{item.domicilio.numero}</b>
                                        </div>
                                    </div>
                                    <div className="d-flex border-bottom">
                                        <div className="col-6" >
                                            <p>Piso</p>
                                            <b>{item.domicilio.piso}</b>
                                        </div>
                                        <div className="col-6" >
                                            <p>Departamento</p>
                                            <b>{item.domicilio.departamento}</b>
                                        </div>
                                    </div>
                                    <div className="d-flex border-bottom">
                                        <div className="col-6" >
                                            <p>Localidad</p>
                                            <b>{item.domicilio.localidad}</b>
                                        </div>
                                    </div>
                                </CardContent>
                            </ExpansionPanel>
                        </Card>
                    )}
                    <Card className="mt-4" style={{ backgroundColor: "#f7f7f7" }}>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div>
                                    <p>ESTABLECIMIENTOS</p>
                                    <div className="d-flex flex-row">
                                        <b className="mr-3">NIVEL: {value.nivelSeleccionado().nivel}</b>
                                        <b className="ml-3">GRADO/AÑO: {value.nivelSeleccionado().grado}</b>
                                    </div>
                                </div>
                            </ExpansionPanelSummary>
                            <CardContent>
                                <h5>Escuelas Seleccionadas</h5>
                                {value.detalleEstablecimientos().map((item, i) =>
                                    <div key={i} className="mt-5 mb-4">
                                        <div className="d-flex mb-2 mt-5">
                                            <div className="col-12" >
                                                <h5>{item.nombre}</h5>
                                                {/*<p>{item.direcion} Email: {item.email}</p>*/}
                                            </div>
                                        </div>
                                        <b className="mt-4 mb-2 ml-5">Datos Relevantes</b>
                                        <div className="d-flex border-bottom">
                                            <div className="col-12" >
                                                <p>¿Tiene hermana/o que curse en el establecimiento?</p>
                                                <b>{item.hermano ? "SI" : "NO"}</b>
                                            </div>
                                        </div>
                                        {item.hermano &&
                                            <>
                                                <div className="d-flex border-bottom">
                                                    <div className="col-12" >
                                                        <p>Nombre del hermana/o</p>
                                                        <b>{item.hermano.apellido}, {item.hermano.nombre}</b>
                                                    </div>
                                                </div>
                                                <div className="d-flex border-bottom">
                                                    <div className="col-6" >
                                                        <p>Número de documento</p>
                                                        <b>{item.hermano.nroDocumento}</b>
                                                    </div>
                                                    <div className="col-6" >
                                                        <p>Grado/Año</p>
                                                        <b>{item.nivelCursoAnio}</b>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        <div className="d-flex border-bottom">
                                            <div className="col-12" >
                                                <p>¿Tiene familiar que trabaje en el establecimiento?</p>
                                                <b>{item.familiar ? "SI" : "NO"}</b>
                                            </div>
                                        </div>
                                        {item.familiar &&
                                            <>
                                                <div className="d-flex border-bottom">
                                                    <div className="col-12" >
                                                        <p>Nombre del familiar</p>
                                                        <b>{item.familiar.apellido}, {item.familiar.nombre}</b>
                                                    </div>
                                                </div>
                                                <div className="d-flex border-bottom">
                                                    <div className="col-6" >
                                                        <p>Número de documento</p>
                                                        <b>{item.familiar.nroDocumento}</b>
                                                    </div>
                                                    {item.vinculoFamiliar &&
                                                        <div className="col-6" >
                                                            <p>Vinculo</p>
                                                            <b>{item.vinculoFamiliar.descripcion}</b>
                                                        </div>
                                                    }
                                                </div>
                                            </>
                                        }
                                        <div className="d-flex border-bottom">
                                            <div className="col-12" >
                                                <p>¿Realizó otra inscripción en este establecimiento?</p>
                                                <b>{item.codigoInscripcionVinculada ? "SI" : "NO"}</b>
                                            </div>
                                        </div>
                                        {item.codigoInscripcionVinculada &&
                                            <div className="d-flex border-bottom">
                                                <div className="col-12" >
                                                    {/*<p>Número de inscripción</p>*/}
                                                    <p>DNI del aspirante de la inscripción vinculada</p>
                                                    <b>{item.codigoInscripcionVinculada}</b>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                )}
                            </CardContent>
                        </ExpansionPanel>
                    </Card>
                    <Card className="mt-4" style={{ backgroundColor: "#f7f7f7" }}>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div>
                                    <p>EXTRAS</p>
                                </div>
                            </ExpansionPanelSummary>
                            <CardContent>
                                <h5>Escuelas Seleccionadas</h5>

                                <div className="d-flex border-bottom">
                                    <div className="col-12" >
                                        <p>¿El aspirante concurrió el año anterior a algún establecimiento de gestión estatal?</p>
                                        <b>{value.detalleExtras().fueEstatal ? "SI: " : "NO"}</b>
                                        {value.detalleExtras().fueEstatal &&
                                            <b>{value.detalleExtras().establecimientoEstatal}</b>
                                        }
                                    </div>
                                </div>
                                <div className="d-flex border-bottom">
                                    <div className="col-12" >
                                        <p>¿El aspirante fue abanderado?</p>
                                        <b>{value.detalleExtras().fueAbanderaro ? "SI: " : "NO"}</b>
                                        {value.detalleExtras().fueAbanderaro &&
                                            <b>{value.detalleExtras().establecimientoBandera}</b>
                                        }
                                    </div>
                                </div>
                            </CardContent>
                        </ExpansionPanel>
                    </Card>
                    <div className="row justify-content-center mb-3 mt-4">
                        {actionsLoading ?
                            <Spinner animation="border" variant="success" />
                            :
                            <>
                                <Volver {...props} />
                                <Button variant="success" size="sm"
                                    onClick={() => {
                                        const auth = sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`);
                                        let authParse;
                                        if (auth) {
                                            authParse = JSON.parse(auth);
                                        }
                                        dispatch(actions.fetchPasoCinco({
                                            inscripcionId: value.valoresExtrasAspirante().inscripcionId,
                                            email: authParse && authParse.profile && authParse.profile.email
                                        }));
                                    }}
                                >Confirmar Solicitud</Button>
                            </>
                        }
                    </div>
                    {error && <SnackBarCustom tipo="error" mensaje={error} />}
                </>
            }
        </PreInscripcionUIConsumer>
    )
}

export default Resumen;